import Audio from '../shared/audio';
import { useBooleanState } from '../../hooks/index/use-boolean-state';
import Button from '../shared/buttons/button';
import { ChevronDoubleUpIcon } from '@heroicons/react/24/outline';
import NavLink from '../shared/buttons/nav-link';

function ExamReportDescription() {
  const { value, toggle } = useBooleanState(false);
  if (!value) {
    return (
      <Button outline size='lg' color='indigo' onClick={toggle} className='mx-auto'>
        توضیحات کارنامه‌ها، زیر گروه‌ها و ضرایب
      </Button>
    );
  }
  return (
    <>
      <Audio
        src='https://medmoshaver.com/shared_files/exam/voices/exam-report.m4a'
        caption='توضیحات صوتی کارنامه‌ها، زیرگروه‌ها و ضرایب'
      />
      <div className='my-6 mx-auto'>
        <p className='text-center'>
          برای مطالعه بیشتر در مورد زیر‌گروه‌ها و ضرایب مربوطه بر روی لینک زیر کلیک کنید.
        </p>
        <NavLink outline to='/edu-sub-groups' className='my-4 mx-auto'>
          توضیحات زیر‌گروه‌ها و ضرایب
        </NavLink>
      </div>
      <ChevronDoubleUpIcon width={20} height={20} onClick={toggle} className='mx-auto' />
    </>
  );
}

export default ExamReportDescription;
